<template>
  <div v-if="this.researchType">
    <v-research-form-tv
      v-if="this.researchType.commercial_type === 'tv'"
      :allow-created-by="true"
      @submit="submit"
    />
    <v-research-form-radio
      v-else-if="this.researchType.commercial_type === 'radio'"
      @submit="submit"
    />
    <v-research-form-ooh
      v-else-if="this.researchType.commercial_type === 'ooh'"
      @submit="submit"
    />
    <v-research-form-custom
      v-else-if="!this.researchType.commercial_type"
      @submit="submit"
    />
  </div>
</template>

<script>
import {
  createResearch,
  fetchCommercialCategories,
  fetchResearchType,
} from '@/organisation/api';
import { mapGetters } from 'vuex';
import {
  notify,
  pageNotFound,
} from '@/common/utils/notify';
import ResearchFormCustom from '@/common/components/research/ResearchFormCustom.vue';
import ResearchFormOOH from '@/common/components/research/ResearchFormOOH.vue';
import ResearchFormRadio from '@/common/components/research/ResearchFormRadio.vue';
import ResearchFormTv from '@/common/components/research/ResearchFormTv.vue';
import { toFormattedDate } from '@/common/utils/formatting';

export default {
  name: 'ResearchCreate',
  components: {
    'v-research-form-custom': ResearchFormCustom,
    'v-research-form-ooh': ResearchFormOOH,
    'v-research-form-radio': ResearchFormRadio,
    'v-research-form-tv': ResearchFormTv,
  },
  data() {
    return {
      categories: [],
      researchType: null,
    };
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    makeFormData(data) {
      const formData = new FormData();
      formData.append('title', data.title);
      if (data.description) {
        formData.append('description', data.description);
      }
      if (data.youtube_id) {
        formData.append('youtube_id', data.youtube_id);
      }
      if (data.categories && data.categories.length > 0) {
        formData.append('category_ids', data.categories.map((e) => (e.id)).join());
      }
      if (data.published_at) {
        formData.append('published_at', toFormattedDate(data.published_at));
      }
      if (data.media_file) {
        formData.append('media_file', data.media_file);
      }
      if (data.created_by_name) {
        formData.append('created_by_name', data.created_by_name);
      }
      if (data.group_size) {
        formData.append('group_size', data.group_size);
      }
      formData.append('research_type', this.$route.params.researchType);
      return formData;
    },
    async getCommercialCategories() {
      const response = await fetchCommercialCategories();
      this.categories = response.data.map((el) => ({
        id: el.id,
        name: el.name,
      }));
    },
    async submit(formData) {
      const response = await createResearch(
        this.org.slug,
        this.makeFormData(formData),
      );
      if (response.status === 201) {
        notify('phrase.create_research_success', 'sentence.add_questions', 'success');
        await this.$router.push({ name: 'organisation-research-edit', params: { uuid: response.data.uuid } });
      } else {
        alert('Er is iets misgegaan. Probeer het nog eens.');
      }
    },
    async fetchResearchType() {
      const response = await fetchResearchType(this.$route.params.researchType, this.org.slug);
      if (response.status === 200) {
        this.researchType = response.data;
      } else {
        pageNotFound();
        await this.$router.push({ name: 'organisation-dashboard' });
      }
    },
  },
  created() {
    this.fetchResearchType();
  },
};
</script>
